import React from 'react';
import PropTypes from 'prop-types';
import SaveAd from '../saveAd';
import { VideoAndVirtualViewingButtons } from '../videoAndVirtualViewing';
import SocialMedia from './socialMedia';

const SharingOptions = ({ heading, finnkode }) => {
    return (
        <div className="my-16 flex justify-between sm:justify-start items-start gap-8 md:gap-16 text-12 md:text-16">
            <SaveAd variant="button" />
            <SocialMedia heading={heading} finnkode={finnkode} />
            <div className="sm:ml-auto flex justify-items gap-8 md:gap-16">
                <VideoAndVirtualViewingButtons />
            </div>
        </div>
    );
};

SharingOptions.propTypes = {
    finnkode: PropTypes.number.isRequired,

    heading: PropTypes.string,
};

export default SharingOptions;
